import { motion } from 'framer-motion';
import { FileText, Clock, CheckCircle, AlertCircle, ArrowRight, Settings } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const tramitesDisponibles = [
  { id: 1, titulo: 'Recategorización de Socio', descripcion: 'Solicite el cambio de categoría de socio', icono: '📋' },
  { id: 2, titulo: 'Ampliación de Póliza de Seguro', descripcion: 'Amplíe la cobertura de su póliza de mala praxis', icono: '🛡️' },
  { id: 3, titulo: 'Cancelación de Membresía', descripcion: 'Solicite la baja de su membresía al CAO', icono: '❌' },
  { id: 4, titulo: 'Certificación de Especialista', descripcion: 'Solicite la certificación o revalidación de su título', icono: '🏆' },
  { id: 5, titulo: 'Registro para Acciones Solidarias', descripcion: 'Inscríbase en el programa de acciones solidarias', icono: '❤️' },
  { id: 6, titulo: 'Modificación de Datos de Tarjeta', descripcion: 'Actualice los datos de su tarjeta para débito automático', icono: '💳' }
];

const Tramites = () => {
  return (
    <div className="space-y-6">
      {/* Banner de configuración pendiente */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Settings className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-medium text-amber-800">Módulo en configuración</p>
            <p className="text-sm text-amber-600">Trámites estará disponible próximamente. A continuación se muestra una vista previa.</p>
          </div>
        </div>
      </div>

      {/* Contenido grisado */}
      <div className="opacity-50 pointer-events-none select-none" data-testid="tramites-page">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-500 mb-2">Trámites</h1>
          <p className="text-gray-400">Gestione sus trámites con el Consejo Argentino de Oftalmología</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tramitesDisponibles.map((tramite) => (
            <Card key={tramite.id} className="hover:shadow-lg transition-all cursor-pointer border-gray-200 bg-gray-50">
              <CardHeader>
                <div className="flex items-start gap-3">
                  <span className="text-3xl grayscale">{tramite.icono}</span>
                  <div>
                    <CardTitle className="text-lg text-gray-500">{tramite.titulo}</CardTitle>
                    <CardDescription className="text-gray-400">{tramite.descripcion}</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <Button className="w-full bg-gray-300 text-gray-500" disabled>
                  Iniciar Trámite <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="mt-8 bg-gray-50 border-gray-200">
          <CardContent className="p-6">
            <h3 className="font-semibold text-gray-500 mb-2">¿Necesita realizar un trámite urgente?</h3>
            <p className="text-gray-400">
              Contacte a gestiones@oftalmologos.org.ar o llame al (011) 4374-5400.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Tramites;
